import { useQuery } from '@tanstack/react-query'
import { IDropdownSelectOption } from '../../common/DropdownSelect/IDropdownSelectOption'
import { societyQueries } from '../../../api/societies'
import { useAuth } from '../../../hooks/useAuth'

export const useSocietyDropdownOptions = (): IDropdownSelectOption[] => {
  const { userId } = useAuth()
  const { data } = useQuery(societyQueries.getUserSocieties(userId))
  const societyOptions = data?.map((society) => ({
    value: society._id,
    label: society.name,
  }))

  return societyOptions || []
}
